import Vue from 'vue'
import VueRouter from 'vue-router'
import Main from '../views/main.vue'
import Login from '../views/login/index.vue'

const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (to) {
    return VueRouterPush.call(this, to).catch(err => err)
}

// replace
const VueRouterReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace (to) {
  return VueRouterReplace.call(this, to).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'Main',
		component: Main,
		meta:{noNav:true},
		directory:false,
	},
	{
		path: '/login',
		name: 'Login',
		component: Login,
		meta: {
			noNav:true
		},
		directory:false,
	},	
	{
		path: '/replace',
		name: 'Replace',
		component: ()=>import('@/views/replace.vue'),
		meta: {
			noNav:true
		},
		directory:false,
	},	
	
	{
		path: '/cardPwdManage',
		name: 'CardPwdManage',
		component: () => import('@/views/cardPwdManage/index.vue'),
		meta: {
			id:2,
			title: '产品管理',
			leven:0,
			parentId:0,
			islink:true,
		},
		directory:true
	},
	{
		path: '/onlineCard',
		name: 'OnlineCard',
		component: () => import('@/views/onlineCard/onlineCard.vue'),
		meta: {
			id:3,
			title: '在线提卡',
			leven:0,
			parentId:0,
			islink:true,
			icon:'el-icon-document',
		},
		directory:true
	},
	
	{
		path: '/orderManage',
		name: 'OrderManage',
		component: () => import('@/views/orderManage/index.vue'),
		meta: {
			id:4,
			title: '提卡记录',
			leven:0,
			parentId:0,
			islink:true,
			icon:'el-icon-document',
		},
		directory:true
	},
	
	
	{
		path: '/ckconfig',
		name: 'Ckconfig',
		component: () => import('@/views/CKConfig/index.vue'),
		meta: {
			id:5,
			title: 'CK配置',
			leven:0,
			parentId:0,
			islink:true,
			icon:'el-icon-document',
		},
		directory:true
	},
	{
		path: '/resetPassword',
		name: 'ResetPassword',
		component: () => import('@/views/setting/resetPassword.vue'),
		meta: {
			id:6,
			title: '重置密码',
			leven:0,
			parentId:0,
			islink:true,
			icon:'el-icon-lock'
		},
		directory:true
	}
]

const router = new VueRouter({
	linkActiveClass: "activeClass",
	/*添加默认样式 activeClass   activeClass 写在组件样式里面   */
	routes
})

export default router
